module.exports = __webpack_public_path__ + "static/media/carousel-1.4949a510.jpg";